export const hasRemainingMessage = (remainingBooking?: number | null) => {
  if (remainingBooking === undefined || remainingBooking === null) return false
  return remainingBooking <= 2 && remainingBooking >= 0
}
